<template>
  <div class="header">
    <div class="left">
      <slot name="changebtn" />
      <!-- <div class="searchbox">
        <el-input
          v-model="value"
          class="searchinput"
          placeholder="搜索你想找的..."
          prefix-icon="el-icon-search"
        />
      </div> -->
    </div>
    <div class="right">
      <!-- <div class="wenhao">
        <i class="el-icon-question big" />
      </div>
      <div class="gonggao">
        <i class="el-icon-message-solid big" />
      </div> -->
      <div class="infoname">
        <div class="name">{{ $store.state.classinfo?.sysUser.nickName }}</div>
        <div class="sf">
          {{ $store.state.classinfo?.sysUser.userIsteacher ? '教师' : '学生' }}
        </div>
      </div>
      <el-popover
        width="100"
        trigger="click"
        popper-class="popper3"
        :offset="40"
      >
        <div @click="godetail(3)" class="div">
          <div class="iconsbox">
            <svg-icon
              style="width: 100%; height: 100%"
              class="icon"
              icon-class="teajiben"
            />
          </div>
          <span v-if="$store.state.classinfo?.sysUser.userIsteacher == 1">
            教师空间
          </span>
          <span v-if="$store.state.classinfo?.sysUser.userIsteacher == 0">
            学生空间
          </span>
        </div>
        <div class="div" @click="logOut">
          <div class="iconsbox">
            <svg-icon
              style="width: 100%; height: 100%"
              class="icon"
              icon-class="teatuichu"
            />
          </div>
          退出登录
        </div>
        <div slot="reference" class="avatorbox">
          <el-image
            :src="$store.state.classinfo?.sysUser.avatar"
            fit="cover"
            style="width: 100%; height: 100%; border-radius: 50%"
          ></el-image>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { resetRouter } from '@/router/index'
export default {
  // 组件名称
  name: 'Header',
  components: {},
  props: {
    inputValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      value: this.inputValue,
      userIsteacher: '',
    }
  },
  computed: {},
  async created() {
    this.getuserInfo()
  },
  methods: {
    godetail(str) {
      this.$router.push({ path: '/user', query: { type: str } })
    },
    logOut() {
      this.$store.dispatch('LOG_OUT').then(() => {
        sessionStorage.removeItem('isr')
        this.$router.push({ path: '/login', query: { refresh: 1 } })
      })
    },
    async getuserInfo() {
      this.userIsteacher = this.$store.state.classinfo?.sysUser.userIsteacher
    },
  },
}
</script>

<style scoped lang="scss">
.icon:hover {
  color: var(--primary) !important;
}
.header {
  width: 100%;
  height: 72px;
  background-color: white;
  border-bottom: 1px solid var(--gray_2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 12px;
  padding-right: 20px;
  z-index: 100;
  .big {
    font-size: 24px;
    cursor: pointer;
  }
  .left {
    display: flex;
    align-items: center;
    .iconsbox {
      cursor: pointer;
    }
    .searchbox {
      margin: 0 20px;
      width: 300px;
    }
    :deep(.searchbox .el-input__inner) {
      height: 36px;
      line-height: 36px;
      border: none;
      background-color: var(--gray_3);
      border-radius: 4px;
    }
    :deep(.searchbox .el-input__icon) {
      line-height: 36px;
    }
  }
  .right {
    display: flex;
    align-items: center;
    .gonggao {
      margin-left: 15px;
      margin-right: 45px;
    }
    .infoname {
      cursor: pointer;
      .name {
        font-size: 16px;
        color: var(--textblack_2);
        text-align: center;
      }
      .sf {
        cursor: pointer;
        font-size: 12px;
        color: var(--gray_2);
        text-align: center;
      }
    }
    .avatorbox {
      cursor: pointer;
      width: 48px;
      height: 48px;
      background-color: var(--gray);
      border-radius: 50%;
      margin-left: 12px;
    }
  }
}
</style>
<style lang="scss">
.popper3 {
  font-size: 16px;
  color: var(--textblack);
  border-radius: 12px;
  padding-top: 15px;
  padding-bottom: 5px;
  .div {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    cursor: pointer;
    color: var(--textblack);
  }
  .div:hover {
    color: var(--primary);
  }
  .iconsbox {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
}
</style>
